module.exports = __webpack_public_path__ + "img/icon-share-primary.2def3810.svg";